import { AnnotationDetailModel, MessageDetailModel } from '../requestsModel'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import AnnotationItem from './AnnotationItem'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'
import { formatDate } from '../../../utils/formatDate'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            reponseContainer: {
                marginBottom: 16,

                '& div p': {
                    margin: 0
                }
            },
            reponseContainerLargeScreen: {
                padding: '35px 35px 35px 50px'
            },
            reponseContainerSmallScreen: {
                padding: 18
            },
            reponseByMe: {
                backgroundColor: 'white'
            },
            reponseByCrm: {
                border: `${theme.palette.accessibility.main} 1px solid`
            },
            contenuReponseContainer: {
                marginBottom: 15,
                whiteSpace: 'pre-line'
            },
            annotationStyleLargeScreen: {
                marginTop: 100
            },
            annotationStyleSmallScreen: {
                marginTop: 20
            },
            badgeContainer: {
                height: 63,
                borderRadius: 32,
                justifyContent: 'center'
            },
            badgeByMe: {
                backgroundColor: theme.palette.blue['10']
            },
            badgeByCrm: {
                backgroundColor: 'white'
            },
            directionRtl: {
                direction: 'rtl'
            },
            infoContainerLargeScreen: {
                marginBottom: 67
            },
            infoContainerSmallScreen: {
                marginBottom: 24
            },
            marginDate: {
                marginTop: '10px !important'
            },
            textAlign: {
                textAlign: 'center'
            },
            imgStyle: {
                paddingLeft: 10,
                width: 48,
                height: 48,
                '& img': {
                    width: 48,
                    height: 48,
                    borderRadius: 50
                }
            }
        }
    )
)

interface Store {
    reponse: MessageDetailModel,
}

type ReponseDetailProps = Store

const ReponseDetail: React.FC<ReponseDetailProps> = (
    {
        reponse,
    }
) => {
    const classes = useStyle()
    const intl = useIntl()
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )

    const reponseContainerClass: ClassValue = classNames(
        'row middle-xs between-xs',
        classes.reponseContainer,
        reponse.sentByMe ? classes.reponseByMe : classes.reponseByCrm,
        {
            [classes.reponseContainerLargeScreen]: isLargeScreen,
            [classes.reponseContainerSmallScreen]: !isLargeScreen
        }
    )

    const contenuReponseClass: ClassValue = classNames(
        'col-xs-10',
        classes.contenuReponseContainer,
        classes.text0
    )

    const annotationClass: ClassValue = classNames(
        'col-xs-12',
        isLargeScreen ? classes.annotationStyleLargeScreen : classes.annotationStyleSmallScreen,
    )

    const infoContainerClass: ClassValue = classNames(
        'col-xs-12 row between-xs',
        isLargeScreen ? classes.infoContainerLargeScreen : classes.infoContainerSmallScreen,
        classes.alignCenter
    )

    const badgeClass: ClassValue = classNames(
        'col-xs-12 col-md-4 row',
        classes.badgeContainer,
        reponse.sentByMe ? classes.badgeByMe : classes.badgeByCrm,
        classes.alignCenter,
        classes.text2
    )

    const dateClass: ClassValue = classNames(
        classes.colorAccessibility,
        classes.text2,
        {
            [classes.directionRtl]: isLargeScreen,
            [classes.marginDate]: !isLargeScreen,
        }
    )

    const authorClass: ClassValue = classNames(
        'col-xs-10',
        classes.textAlign
    )

    const imgClass: ClassValue = classNames(
        'col-xs-2',
        classes.imgStyle
    )

    let badgeLabelProp = reponse.sentByMe ? {
        id: 'requests.detail.sentAMessage',
        defaultMessage: 'Vous avez envoyé un message',
        description: 'Vous avez envoyé un message'
    } : {
        id: 'requests.detail.responseService',
        defaultMessage: 'Votre équipe YouFirst',
        description: 'Votre équipe YouFirst'
    }

    return <div className={reponseContainerClass}>
        <div className={infoContainerClass}>
            <div className={badgeClass}>
                {!reponse.sentByMe && <div className={imgClass}><img src="img/default_thumbnail.png" alt="yf Manager icon" height={40} /></div>}
                <div className={authorClass}><p><FormattedMessage{...badgeLabelProp} /></p></div>
            </div>
            <div className="col-xs-12 col-md-2">
                <p className={dateClass}>{formatDate(reponse.modifiedOn, intl.locale)}</p>
            </div>
        </div>
        <div className={contenuReponseClass}>
            {reponse.message}
        </div>
        {reponse.annotation.length > 0 && (<div className={annotationClass}>
            <div className={classes.text2}>
                <FormattedMessage
                    id="requests.detail.myAnnotations"
                    defaultMessage="Vous avez joint des fichiers"
                    description="Fichiers joints"
                    values={{
                        nbAnnotations: reponse.annotation.length
                    }}
                />
            </div>
            {reponse.annotation.map((item: AnnotationDetailModel, index) =>
                <div key={`${reponse.id}-annotation-${index}`}>
                    <AnnotationItem annotation={item} whiteMode={!reponse.sentByMe} />
                </div>
            )}
        </div>)}
    </div>
}

export default ReponseDetail
